import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TabName } from '../../../models/_enum-collections';
import { EngagementSearchAndFilterInput } from '../../../models/engagement-search-and-filter-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { MrppCustomerAckTableComponent } from '../mrpp-customer-ack-table/mrpp-customer-ack-table.component';

@Component({
  selector: 'app-customer-acknowledgement',
  templateUrl: './customer-acknowledgement.component.html',
  styleUrls: ['./customer-acknowledgement.component.scss'],
  standalone: true,
  imports: [MrppCustomerAckTableComponent]
})
export class CustomerAcknowledgementComponent implements OnInit {
  searchAndFilterInput: EngagementSearchAndFilterInput =
    new EngagementSearchAndFilterInput();
  currentSearchSubscription!: Subscription;

  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.CustomerAckApproval;
    this.prevDocumentType = PreviewDocumentTypes.customerAcknowledgement;
  }
}
